import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
import { ShopMetaFragmentDoc } from './shop-meta.gql.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ShopSubscriptionVariantFragment = { __typename: 'ShopSubscriptionVariantObject', id: number, name: string, description?: string | null | undefined, interval: Types.SubscriptionRunInterval, price: { __typename: 'ShopCurrencyObject', amount: number, currency: string } };

export type ShopSubscriptionFragment = { __typename: 'ShopSubscriptionObject', id: number, name: string, locale: string, description?: string | null | undefined, contentRef?: string | null | undefined, termsUrl?: string | null | undefined, variants: Array<{ __typename: 'ShopSubscriptionVariantObject', id: number, name: string, description?: string | null | undefined, interval: Types.SubscriptionRunInterval, price: { __typename: 'ShopCurrencyObject', amount: number, currency: string } }>, meta: { __typename: 'ShopMetaContentObject', description?: string | null | undefined, title?: string | null | undefined, keywords?: string | null | undefined } };

export type ShopSubscriptionsQueryVariables = Types.Exact<{
  locale: Types.Scalars['String']['input'];
  channelCode: Types.Scalars['String']['input'];
}>;


export type ShopSubscriptionsQuery = { __typename: 'Query', shopSubscriptions: Array<{ __typename: 'ShopSubscriptionObject', id: number, name: string, locale: string, description?: string | null | undefined, contentRef?: string | null | undefined, termsUrl?: string | null | undefined, variants: Array<{ __typename: 'ShopSubscriptionVariantObject', id: number, name: string, description?: string | null | undefined, interval: Types.SubscriptionRunInterval, price: { __typename: 'ShopCurrencyObject', amount: number, currency: string } }>, meta: { __typename: 'ShopMetaContentObject', description?: string | null | undefined, title?: string | null | undefined, keywords?: string | null | undefined } }> };

export type ShopSubscriptionQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  locale: Types.Scalars['String']['input'];
  channelCode: Types.Scalars['String']['input'];
}>;


export type ShopSubscriptionQuery = { __typename: 'Query', shopSubscription: { __typename: 'ShopSubscriptionObject', id: number, name: string, locale: string, description?: string | null | undefined, contentRef?: string | null | undefined, termsUrl?: string | null | undefined, variants: Array<{ __typename: 'ShopSubscriptionVariantObject', id: number, name: string, description?: string | null | undefined, interval: Types.SubscriptionRunInterval, price: { __typename: 'ShopCurrencyObject', amount: number, currency: string } }>, meta: { __typename: 'ShopMetaContentObject', description?: string | null | undefined, title?: string | null | undefined, keywords?: string | null | undefined } } };

export type ShopSubscriptionTermsUrlQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  locale: Types.Scalars['String']['input'];
  channelCode: Types.Scalars['String']['input'];
}>;


export type ShopSubscriptionTermsUrlQuery = { __typename: 'Query', shopSubscription: { __typename: 'ShopSubscriptionObject', termsUrl?: string | null | undefined } };

export const ShopSubscriptionVariantFragmentDoc = gql`
    fragment ShopSubscriptionVariant on ShopSubscriptionVariantObject {
  id
  name
  description
  interval
  price {
    amount
    currency
  }
}
    `;
export const ShopSubscriptionFragmentDoc = gql`
    fragment ShopSubscription on ShopSubscriptionObject {
  id
  name
  locale
  description
  contentRef
  termsUrl
  variants {
    ...ShopSubscriptionVariant
  }
  meta {
    ...ShopMeta
  }
}
    ${ShopSubscriptionVariantFragmentDoc}
${ShopMetaFragmentDoc}`;
export const ShopSubscriptionsDocument = gql`
    query ShopSubscriptions($locale: String!, $channelCode: String!) {
  shopSubscriptions(locale: $locale, channelCode: $channelCode) {
    ...ShopSubscription
  }
}
    ${ShopSubscriptionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopSubscriptionsGQL extends Apollo.Query<ShopSubscriptionsQuery, ShopSubscriptionsQueryVariables> {
    document = ShopSubscriptionsDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopSubscriptionDocument = gql`
    query ShopSubscription($id: Int!, $locale: String!, $channelCode: String!) {
  shopSubscription(id: $id, locale: $locale, channelCode: $channelCode) {
    ...ShopSubscription
  }
}
    ${ShopSubscriptionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopSubscriptionGQL extends Apollo.Query<ShopSubscriptionQuery, ShopSubscriptionQueryVariables> {
    document = ShopSubscriptionDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopSubscriptionTermsUrlDocument = gql`
    query ShopSubscriptionTermsUrl($id: Int!, $locale: String!, $channelCode: String!) {
  shopSubscription(id: $id, locale: $locale, channelCode: $channelCode) {
    termsUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopSubscriptionTermsUrlGQL extends Apollo.Query<ShopSubscriptionTermsUrlQuery, ShopSubscriptionTermsUrlQueryVariables> {
    document = ShopSubscriptionTermsUrlDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }